/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { use } from 'i18next'
import { initReactI18next } from 'react-i18next'
import spanish from './translations/es.json'
import english from './translations/en.json'
import portuguese from './translations/pt.json'

use(initReactI18next).init({
  fallbackLng: ['en'],
  debug: false,
  returnNull: false,
  supportedLngs: ['en', 'es', 'pt'],
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: { translation: english },
    es: { translation: spanish },
    pt: { translation: portuguese }
  }
})
